import useFetch from 'utils/hooks/useFetch'
import { ApiGetDashboardInfo } from 'utils/constants/api'
import { CheckResponse } from 'utils/helpers'
import { useModal } from 'utils/context/ModalContext'

export function DashboardService() {
    const { showFail } = useModal()

    const { fetch: apiGetDashboardInfo } = useFetch(ApiGetDashboardInfo)
 
    const fetchDashboardInfo = async (expenseMonth, expenseYear, paymentMonth, paymentYear) => {
        const res = await apiGetDashboardInfo({
            data: {
                expenseMonth,
                expenseYear,
                paymentMonth,
                paymentYear
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return {
        fetchDashboardInfo,
    }
}